import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Alert } from "./alert";

// Built on shadcn's Alert for the role="alert" announcement, but keeping the
// app's own geometry and status colours rather than Alert's card styling.
// ``warn``: something the reader must check, neither a failure nor a success.
export function Banner({ tone, children }: { tone: "error" | "success" | "warn"; children: ReactNode }) {
  return (
    <Alert
      className={cn(
        "mb-3.5 rounded-lg border px-3.5 py-3 text-[length:inherit]",
        tone === "error"
          ? "border-destructive-line bg-destructive-surface text-destructive"
          : tone === "warn"
            ? "border-warning text-warning-foreground"
            : "border-success-line bg-success-surface text-success",
      )}
    >
      {children}
    </Alert>
  );
}
